export default "__VITE_ASSET__DfIT1ZZk__"